import { render, staticRenderFns } from "./EffectControlCard.vue?vue&type=template&id=6a013ab0&scoped=true"
import script from "./EffectControlCard.vue?vue&type=script&lang=js"
export * from "./EffectControlCard.vue?vue&type=script&lang=js"
import style0 from "./EffectControlCard.vue?vue&type=style&index=0&id=6a013ab0&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6a013ab0",
  null
  
)

export default component.exports